import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 32024 29919"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str1{stroke:#000;stroke-width:915.005}.str2{stroke:#2b2a29;stroke-width:348.617}.fil0{fill:none}.fil1{fill:#1c1b17}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M4592 6675h22830v16581H4592z"
        className="fill-none stroke1"
        style={{
          stroke: "#2b2a29",
          strokeWidth: 807.035,
        }}
      />
      <path
        d="M486 27879c52 298 454 873 755 1123 542 450 878 444 1434 444h26270c790 0 978 116 1630-287 420-260 621-527 854-1011 165-341 120-393 120-813-1-2258 48-25004-12-25290-28-136-236-524-319-650-135-205-269-337-449-484-552-449-886-422-1435-423l-18770-16c-2488 0-5017-43-7500 18-663 18-1087-19-1608 289-304 180-742 600-850 1013-191 730-137 2713-140 3586-3 941-26 22233 20 22501z"
        className="stroke1 fill-none"
        style={{
          strokeWidth: 915.005,
        }}

      />
      <path
        d="M10830 21167c213-57 569-262 777-366 273-137 510-259 777-389 535-260 1026-519 1555-778l6165-3083c517-264 1009-509 1522-772 315-162 1315-611 1541-802-41-57 2-13-63-63-222-171-9725-4882-10709-5382l-1554-768-11 12403z"
        className="stroke1 fill"
        style={{
          strokeWidth: 915.005,
        }}
      />
      <path
        d="M4844 2333h3660v1832H4844zM11066 2332h3660v1833h-3660zM17288 2332h3660v1833h-3660zM23510 2332h3660v1833h-3660zM4844 25954h3660v1832H4844zM11066 25954h3660v1833h-3660zM17288 25954h3660v1833h-3660zM23510 25954h3660v1833h-3660z"
        className="stroke1 fill"
        style={{
          strokeWidth: 348.617,
        }}
      />
    </g>
  </svg>
)
export default SvgComponent
